import { CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';

const MAP = {
  atteint: { label: 'Objectif atteint', cls: 'bg-emerald-50 text-emerald-700 ring-emerald-200', Icon: CheckCircle2 },
  attention: { label: 'Attention', cls: 'bg-amber-50 text-amber-800 ring-amber-200', Icon: AlertTriangle },
  retard: { label: 'Retard', cls: 'bg-rose-50 text-rose-700 ring-rose-200', Icon: XCircle },
};

export const StatusPill = ({ status, compact = false, className = '' }) => {
  const cfg = MAP[status] || MAP.attention;
  const { Icon } = cfg;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${cfg.cls} ${className}`} data-testid="objective-status-pill">
      <Icon className="h-3.5 w-3.5" />
      {!compact && cfg.label}
    </span>
  );
};
